import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "antd";
import MenuItemLayout from "../menuItemLayout/MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import Loader from "../../../biblio/Loader/Loader";
import { getNewsDetails } from "../../../apis/actions/news.actions";
import { RootState, AppDispatch } from "../../../apis/store";
import { NewsDetailsType } from "../../../interfaces/News.types";
import DotsLoader from "../../../biblio/Loader/DotsLoader";

const NewsDetails = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const newsDetails = useSelector(
    (state: RootState) => state.news.newsDetails as NewsDetailsType
  );
  const loading = useSelector((state: RootState) => state.news.loading);
  const navigate = useNavigate();

  const id = location.state?.id;

  useEffect(() => {
    if (id) {
      dispatch(getNewsDetails(id));
    } else {
      navigate("/news");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id]);

  if (loading) {
    return <Loader />;
  }

  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="الأخبار"
      subTitle="تفاصيل الخبر"
      urlImage={banner}
    >
      {loading ? (
        <div className="takaful--loading-branches">
          <DotsLoader />
          <p className="takaful--no-project-message">جارٍ التحميل</p>
        </div>
      ) : (
        <Row dir="rtl" gutter={[8, 8]}>
          <Col
            xxl={12}
            xl={11}
            lg={12}
            md={12}
            sm={12}
            xs={24}
            className="takaful--right-col"
            style={{ textAlign: "end" }}
          >
            <div className="takaful--details-news-card">
              <div className="takaful--details-news-card-image-container">
                <img
                  className="takaful--details-news-card-main-image"
                  src={`data:image/png;base64,${newsDetails?.image}`}
                  alt={newsDetails?.title}
                />
                <div className="takaful--details-news-card-overlay">
                  <p className="takaful--details-news-card-date">
                  {new Date(newsDetails?.published_date).toLocaleDateString()}
                  </p>
                  <p className="takaful--details-news-card-title">
                    {newsDetails?.title}
                  </p>
                </div>
              </div>
              <p className="takaful--details-news-card-resume">
                {newsDetails?.resume}
              </p>
            </div>
          </Col>
          <Col xxl={10} xl={12} lg={8} md={8} sm={8} xs={23}>
            <Row gutter={[16, 16]} dir="rtl">
              {newsDetails?.image_ids?.length > 0 &&
                newsDetails.image_ids.map((image, index) => (
                  <Col
                    key={index}
                    xxl={12}
                    xl={12}
                    lg={24}
                    md={24}
                    sm={24}
                    xs={24}
                  >
                    <div className="takaful--details-news-cards">
                      <img
                        className="takaful--details-news-card-main-images"
                        src={image.attachment_ids}
                        alt={newsDetails?.title}
                      />
                      <div className="takaful--details-news-card-descriptions">
                        <p className="takaful--details-news-card-dates">
                        {new Date(newsDetails?.published_date).toLocaleDateString()}
                        </p>
                      </div>
                    </div>
                    <p className="takaful--details-news-card-resumes">
                      {image?.description}
                    </p>
                  </Col>
                ))}
            </Row>
          </Col>
        </Row>
      )}
    </MenuItemLayout>
  );
};

export default NewsDetails;
